import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export async function generateCollectionsBrief({ propertyId, snapshot, baselineBrief }) {
  const callable = httpsCallable(functions, 'generateCollectionsBrief');
  const result = await callable({
    propertyId,
    snapshot: {
      ...snapshot,
      baselineBrief,
    },
  });

  return result.data?.brief || null;
}

export function getAiBriefErrorMessage(error) {
  const message = String(error?.message || '');

  if (message.includes('OPENAI_API_KEY')) {
    return 'The dashboard is wired for live AI briefs, but OPENAI_API_KEY is not configured in Cloud Functions yet.';
  }

  if (message.includes('not-found') || message.includes('404')) {
    return 'The live AI brief function is not deployed yet. The dashboard can still show the rules-based preview until Functions are live.';
  }

  if (message.includes('permission-denied')) {
    return 'This property could not be analyzed because the signed-in user does not own it.';
  }

  return 'The live AI brief could not be generated right now, so Tenafi is showing the grounded rules preview instead.';
}
